'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'salad';
var width = 512;
var height = 512;
var aliases = [129367,"bowl-salad"];
var unicode = 'f81e';
var svgPathData = 'M512 240c0-49.86-28.1-92.82-70.87-113.8c-12.5-33.24-42.5-56.61-77.75-60.98c-12.75-2-24.05-.8216-36.43 2.551C309.2 26.67 268.6 0 223.8 0C179 0 138.5 26.74 120.9 67.86C103 62.98 91.25 64.11 84.25 65.23C38 70.73 2.504 108.7 .1289 155.2c-1 15.1 4.125 36.99 10.62 49.11c9 16.1 15.88 34.99 19 53.61c-7.375 1.748-14.38 4.998-19.62 10.75c-7.25 7.873-10.88 18.37-10 28.99c6.25 72.86 51.38 136.5 116.6 166.3C119.6 490.9 142.1 512 169.5 512h173.6c27.38 0 50.13-21.12 52.75-48.24c65-29.99 109.9-93.48 116-166.1c.625-7.748-1.875-15.12-5.75-21.87C509.6 264.4 512 252.5 512 240zM208 112C208 103.2 215.2 96 224 96s16 7.156 16 16V256h-32V112zM68.69 148.7c6.25-6.25 16.38-6.25 22.62 0L198.6 256H153.4L68.69 171.3C62.44 165.1 62.44 154.9 68.69 148.7zM364 425l-15.75 5.748v27.49c0 3.25-2.375 5.75-5.125 5.75H169.5c-2.75 0-5.125-2.5-5.125-5.75v-27.37l-15.88-5.623c-52.75-18.1-90.75-65.86-99.25-121.2h413.5C454.4 359.3 416.5 406 364 425zM461.8 256.1h-155.6c-1.125-5.25-2.25-10.37-2.25-15.1c0-44.24 35.88-79.98 80-79.98c46.13 0 80.13 38.87 80.13 79.98C464 245.7 462.9 250.8 461.8 256.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSalad = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;